import { render, staticRenderFns } from "./jsjdwts.vue?vue&type=template&id=67bfb15a&scoped=true&"
import script from "./jsjdwts.vue?vue&type=script&lang=js&"
export * from "./jsjdwts.vue?vue&type=script&lang=js&"
import style0 from "./jsjdwts.vue?vue&type=style&index=0&id=67bfb15a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bfb15a",
  null
  
)

export default component.exports